<template>
    <div>
        <create-user-form
            ref="createForm"
            @success="userCreated()"
            @error="showError"
            @cancel="hideModal()"
        ></create-user-form>

        <users-table title="Users" @addUser="showUserModal()" ref="userTable">
            <b-button
                v-if="hasPermissionCreate"
                variant="primary"
                @click="showUserModal"
                >Add User</b-button
            >
        </users-table>
    </div>
</template>
<script>
import UsersTable from './Users/UsersTable'
import CreateUserForm from './Users/CreateUserForm'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'users',
    components: {
        UsersTable,
        CreateUserForm,
    },
    mixins: [popupMixins, permissionsMixins],
    data: () => {
        return {
            componentName: 'User',
        }
    },
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        hideModal() {
            this.$refs.createForm.showModal()
        },
        showUserModal() {
            this.$refs.createForm.showModal()
        },

        showError(error, email) {
            const interror = 'Internal Server Error'
            if (interror == error.message) {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `The email address "${email}" is already taken. Please create a user with a different email address`
                )
            }
        },
        userCreated() {
            this.genericToast(
                this.componentName,
                'Created',
                'success',
                'User has been created successfully'
            )

            this.$refs.userTable.doSearch()
        },
    },

    mounted() {},
}
</script>
<style></style>
